import {useState} from 'react'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { selectedDate, setselectedDate } from  "react-datepicker";
import Booking from "./Booking";
import Testimonials from "./Testimonials";
export default function WeddingEvents() {

  const [dateRange, setDateRange, setStartDate] = useState([null, null]);
  const [startDate, endDate] = dateRange;

  // const [startDate setStartDate1] = useState(new Date());

    return (
      <>
      <div className="wedding-events-page" id="wedding-events-page">
    
        <section className="inner-banner-area rooms-hero">
          <img src="img/room-hero-banner.avif" className="w-100" />
          <div className="container">
            <div className="contact-banner">
                <div className="text-center">
                <h2 className="inner-banner-heading">Weddings & Events</h2>
                    <nav aria-label="breadcrumb" className="banner-breadcrumb">
                        <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="index.php">Home</a></li>
                        <li className="breadcrumb-item active" aria-current="page">Weddings & Events</li>
                        </ol>
                    </nav>
                </div>
            </div>
            </div>
        </section>

        <Booking></Booking>


        <section className="section-margin section-margin--small">
    <div className="container">
        <div className="section-intro text-center pb-80px">
            <h1 className="inner-section-main-heading">Weddings & Events</h1>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-10">
            <div className="cta-box-content text-center">
              <h3 className="cta-heading mb-4">Celebrate Precious Moments at Our Venues In Vasant Kunj</h3>
                <p>The Grand New Delhi is home to versatile banquet halls and lawns for meetings, events and weddings in Vasant Kunj spread over 30,000 square feet. While in close proximity to major corporate hubs as well as residential districts, our location is perfect as a conference and meeting venue as well as an ideal place for wedding and social get togethers. Our state-of-the-art technology, infrastructure, meeting concierge along with dedicated event services teams ensure the success of every event.</p>
            </div>
          </div>
        </div>
        
    </div>
</section>



<section className="home-mid-sec">
  <div className="container-fluid p-0">

    <div className="row repeated-block">
      <div className="col-lg-5 align-self-center text-column">
        <div className="text-box-block">
          <h4 className="text-block-title">
            The Grand Ballroom
          </h4>
          <p>
          Exuding sheer luxury, the 6,500 square feet pillar-less ballroom in Vasant Kunj is known to host a diverse range of functions from corporate events, product launches, conferences, seminars to private parties, weddings, fashion shows, exhibitions and more and can easily host over 2000 guests. The ballroom, having a spacious pre-function area and an expansive outdoor garden area adjacent to it, can be further partitioned into separate halls for smaller meetings and conferences. Space extends professional event planner, specialized menus and exotic décor and wired audio-visual technology.
          </p>
          <p>This is one of the most extravagantly decked wedding halls in New Delhi, which has a separate grand entrance for direct access into the ballroom and ample car parking facilities to enhance the expediency for guests.</p>
          <div className="text-box-btns">
            <a href="#" className="btn book-now-hero" data-bs-toggle="modal" data-bs-target="#wedding-events-enquiry" >Enquire Now</a>
          </div>
        </div>
      </div>
      <div className="col-lg-7 p-0 image-column">
        <div className="img-block">
          <img src="img/new-event-img.jpg" className="w-100" alt="wedding and events" />
        </div>
      </div>
    </div>

    <div className="row repeated-block">
      <div className="col-lg-5 align-self-center text-column">
        <div className="text-box-block">
          <h4 className="text-block-title">
            Cascades Top Garden - A Lush Green Outdoor Event Venue in New Delhi
          </h4>
          <p>
         Our 5-star hotel in Delhi's beautifully landscaped garden, Cascade Top Garden, is ideal for cocktail receptions or outdoor events in Vasant Kunj. This outdoor event venue in New Delhi enjoys a stunning view of the surroundings and can easily accommodate up to 350 guests in a Cocktail Setting.
          </p>
        
          <div className="text-box-btns">
            <a href="#" className="btn book-now-hero" data-bs-toggle="modal" data-bs-target="#wedding-events-enquiry" >Enquire Now</a>
          </div>
        </div>
      </div>
      <div className="col-lg-7 p-0 image-column">
        <div className="img-block">
          <img src="img/cascades.avif" className="w-100" alt="wedding and events" />
        </div>
      </div>
    </div>

    <div className="row repeated-block">
      <div className="col-lg-5 align-self-center text-column">
        <div className="text-box-block">
          <h4 className="text-block-title">
            Grand Greens - One of the Best Wedding Venues in New Delhi
          </h4>
          <p>
            Grand Greens is one of the best wedding venues in Delhi with 14,000 square feet of lush green garden area. This banquet hall in New Delhi is the ideal venue for the larger than life wedding functions and parties, large-scale gatherings, concerts, social events.
          </p>
        
          <div className="text-box-btns">
           <a href="#" className="btn book-now-hero" data-bs-toggle="modal" data-bs-target="#wedding-events-enquiry" >Enquire Now</a>
          </div>
        </div>
      </div>
      <div className="col-lg-7 p-0 image-column">
        <div className="img-block">
          <img src="img/garden-greens.avif" className="w-100" alt="wedding and events" />
        </div>
      </div>
    </div>

    <div className="row repeated-block">
      <div className="col-lg-5 align-self-center text-column">
        <div className="text-box-block">
          <h4 className="text-block-title">
            Jade - A Conference Venue
          </h4>
          <p>
            Jade at The Grand New Delhi is a 1,700 square feet hall in Vasant Kunj with plush interiors and modern facilities. With a capacity to hold up to 100 people in theatre formation, this conference hall in New Delhi is a perfect venue for corporate events.
          </p>
          <div className="text-box-btns">
            <a href="#" className="btn book-now-hero" data-bs-toggle="modal" data-bs-target="#wedding-events-enquiry" >Enquire Now</a>
          </div>
        </div>
      </div>
      <div className="col-lg-7 p-0 image-column">
        <div className="img-block">
          <img src="img/conference-venue.jpg" className="w-100" alt="wedding and events" />
        </div>
      </div>
    </div>

    <div className="row repeated-block">
      <div className="col-lg-5 align-self-center text-column">
        <div className="text-box-block">
          <h4 className="text-block-title">
            Emerald Banquet - A state-of-the-art hall for your celebrations
          </h4>
          <p>
            The Emerald banquet hall is spread over 540 square feet and transcends the realm of ordinary event venues. Offering an enchanting space where memorable moments are crafted with sophistication, our Emerald Banquet Hall is a formal/semi-formal hall that can hold up to 50 people.
          </p>
          <p>Book your stay at The Grand New Delhi and experience the true luxury of our Emerald banquet.</p>
          <div className="text-box-btns">
            <a href="#" className="btn book-now-hero" data-bs-toggle="modal" data-bs-target="#wedding-events-enquiry" >Enquire Now</a>
          </div>
        </div>
      </div>
      <div className="col-lg-7 p-0 image-column">
        <div className="img-block">
          <img src="img/emarald-img.avif" className="w-100" alt="wedding and events" />
        </div>
      </div>
    </div>

    <div className="row repeated-block">
      <div className="col-lg-5 align-self-center text-column">
        <div className="text-box-block">
          <h4 className="text-block-title">
            Board Room - A Meeting Venue in New Delhi
          </h4>
          <p>
            The Board Room at The Grand New Delhi has been designed keeping in mind the needs of the modern day business meeting. The meeting hall in Vasant Kunj is equipped with all contemporary amenities, high-speed internet and conference facility. This boardroom is one of the finest meeting venues in New Delhi.</p>
          <div className="text-box-btns">
            <a href="#" className="btn book-now-hero" data-bs-toggle="modal" data-bs-target="#wedding-events-enquiry" >Enquire Now</a>
          </div>
        </div>
      </div>
      <div className="col-lg-7 p-0 image-column">
        <div className="img-block">
          <img src="img/board-room-img.avif" className="w-100" alt="wedding and events" />
        </div>
      </div>
    </div>

    <div className="row repeated-block">
      <div className="col-lg-5 align-self-center text-column">
        <div className="text-box-block">
          <h4 className="text-block-title">
           Drawing Room - An Elegantly Decked Meeting Venue in New Delhi
          </h4>
          <p>
           The Drawing room is equipped with modern amenities and is a perfect meeting venue in New Delhi if you are looking for small private meetings 400 square feet of premium floor space has plush comfortable seating and full refreshment service available. It can accommodate up to 10 delegates.</p>
          <div className="text-box-btns">
            
            <a href="#" className="btn book-now-hero" data-bs-toggle="modal" data-bs-target="#wedding-events-enquiry" >Enquire Now</a>
          </div>
        </div>
      </div>
      <div className="col-lg-7 p-0 image-column">
        <div className="img-block">
          <img src="img/drawing-room-img.avif" className="w-100" alt="wedding and events" />
        </div>
      </div>
    </div>

    <div className="row repeated-block">
      <div className="col-lg-5 align-self-center text-column">
        <div className="text-box-block">
          <h4 className="text-block-title">
            Grand Socials & Weddings Venues in New Delhi at The Grand
          </h4>
          <p>
            For all the special occasions that bring you closer to your family, friends and loved ones, weddings & socials at our 5-star hotel near New Delhi Airport - The Grand New Delhi, stand shoulder-to-shoulder with you at all your events to make it a grand success. To celebrate these events, our team of professionals will join hands with you and stand by at every step to ensure every process is run smoothly and perfectly.
          </p>
          <p><strong>Host your special day at one of the best wedding venues in New Delhi!</strong> </p>
          <div className="text-box-btns">
           <a href="#" className="btn book-now-hero" data-bs-toggle="modal" data-bs-target="#wedding-events-enquiry" >Enquire Now</a>
          </div>
          
        </div>
      </div>
      <div className="col-lg-7 p-0 image-column">
        <div className="img-block">
          <img src="img/wedding-event.jpg" className="w-100" alt="wedding and events" />
        </div>
      </div>
    </div>

    

    

  </div>
</section>




</div>

<Testimonials></Testimonials>


<div className="modal fade" id="wedding-events-enquiry" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div className="modal-dialog">
              <div className="modal-content">
                  <div className="modal-body">
                      <h5 className="modal-title">Enquire Now</h5>
                      <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                      <div className="fixed-form fixed">
                           <form method="post" action="event_mail.php">
                              <div className="form row">
                                  <div className="col-12 form-group">
                                      <input type="text" className="form-control"  name="fname" placeholder="First Name*" required />
                                  </div>
                                  <div className="col-12 form-group">
                                      <input type="text" className="form-control"  name="lname" placeholder="Last Name*" required />
                                  </div>
                                  <div className="col-12 form-group">
                                      <input type="phone" className="form-control" name="phone"  placeholder="Phone*" required/>
                                  </div>
                                  <div className="col-12 form-group">
                                      <input type="email" className="form-control" name="email"  placeholder="Email*" required />
                                  </div>
                                  <div className="col-12 form-group">
                                  <DatePicker
      dateFormat="dd/MM/yyyy"
      selected={startDate}
      onChange={(date) => setStartDate(date)}
    />
                                      {/* <input type="text" className="form-control" id="checkindate" placeholder="Checkin" name="checkindate" readonly="" /> */}
                                  </div>
                                  <div className="col-12 form-group">
                                      <input type="text" className="form-control" id="checkoutdate" placeholder="Checkout" name="checkoutdate" readonly="" />
                                  </div>
                                  
                                  <div className="col-12 form-group">

                                      <select className="form-select form-control" name="event_type" aria-label="Default select example">
                                        <option value="The Grand Ballroom" selected>The Grand Ballroom</option>
                                        <option value="Cascades Top Garden">Cascades Top Garden</option>
                                        <option value="Garden Greens">Garden Greens</option>
                                        <option value="Jade">Jade</option>
                                        <option value="Emerald">Emerald</option>
                                        <option value="The Grand Boardroom">The Grand Boardroom</option>
                                        <option value="Drawing Room">Drawing Room</option>
                                        <option value="Weddings & Socials In Delhi">Weddings & Socials</option>
                                        
                                      </select>
                                  </div>

                                  <div className="col-12 form-group">

                                      <input type="text" className="form-control" placeholder="No of Guest" name="noofguest" />
                                  </div>

                                  <div className="col-12 form-group">
                                      <textarea className="form-control" placeholder="Message" rows="3" name="message" required></textarea>
                                  </div>
                                 
                                  <div className="col-12 formFooter">
                                      <button type="submit" name="Submit" value="Submit" className="btn mx-auto">Submit</button>
                                  </div>
                              </div>
                          </form>
                      </div>
                  </div>
              </div>
          </div>
      </div>


      </>
    );
  }
  